export const GuestBookingClientDetails = "3e894a5c09a6f8d42ec244d2f098e03c0f1c7e408650ad0a71bdffe2b17de031";